import _ from 'underscore';

function createFilterQuery(labels, containsAll, isMCCLabelEnabled) {
  const labelIds = isMCCLabelEnabled ? _.map(labels, label => JSON.stringify(_.pick(label, 'Id', 'Scope'))) : _.pluck(labels, 'Id');
  const query = containsAll ?
    {
      Labels: {
        $containsall: labelIds,
      },
    } :
    {
      Labels: {
        $containsany: labelIds,
      },
    };

  return query;
}

export function triggerFilter(labels, grid, containsAll, filterService, isMCCLabelEnabled = false) {
  // currently in new adgroup grid the filterState is mock
  if (filterService) {
    const filterQuery = createFilterQuery(labels, containsAll, isMCCLabelEnabled);
    return filterService.setEditableFilter(filterQuery);
  }

  if (grid && grid.filterState) {
    const newFilter = grid.filterState.createFilter({
      query: createFilterQuery(labels, containsAll, isMCCLabelEnabled),
    });

    return grid.filterState.setFilter(newFilter);
  }

  return undefined;
}


export function filterOnLabelClick(event, labels, gridView, filterService, isMCCLabelEnabled) {
  if (!isMCCLabelEnabled) {
    return undefined;
  }

  const dataIdAttr = 'data-id';
  const dataScopeAttr = 'data-scope';
  const { currentTarget } = event;
  const labelId = parseInt(currentTarget.getAttribute(dataIdAttr), 10);
  const scope = currentTarget.getAttribute(dataScopeAttr);
  const label = labels.find(l => l.Id === labelId && l.Scope === scope);

  if (label) {
    return triggerFilter([label], gridView, true, filterService, isMCCLabelEnabled);
  }
  return undefined;
}

export function navigateToManagePage(router) {
  router.navigateToRoute('label_manage', {});
}

